import React from 'react';
import _, { get } from 'lodash';
import PropTypes from 'prop-types';
import StatusIcon from 'modules/common/components/StatusIcon';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';

function Processor({ label, name, date }) {
  return (
    <>
      <tr>
        <td className="text-primary" colSpan={12}>
          <b>{label}</b>
        </td>
      </tr>
      <tr>
        <td className="text-dark" colSpan={8}>
          Name
        </td>
        <td className="text-dark" width="1">
          :
        </td>
        <td colSpan={4}>
          <b>{name ? `${name}`.trim() : '-'}</b>
        </td>
      </tr>
      <tr>
        <td className="text-dark" colSpan={8}>
          Date
        </td>
        <td className="text-dark" width="1">
          :
        </td>
        <td colSpan={4}>
          <b>{date || '-'}</b>
        </td>
      </tr>
    </>
  );
}

Processor.defaultProps = {
  label: '',
  name: '',
  date: '',
};

Processor.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  date: PropTypes.string,
};

function TransactionInformation({
  data,
  handleUpdateBarangayBusinessClearanceNumber,
  handleUpdateBusinessPlateNumber,
}) {
  const permissions = getJson('permissions');
  const spanGap = 8;
  const transmitallNo = get(
    data,
    'included.bplsApplication.attributes.transmittal_no'
  );
  const businessPlateNo = get(
    data,
    'included.bplsApplication.attributes.business_plate_number'
  );

  const getApplicationStatus = status => {
    if (status === 'FOR PERMIT PROCESS') {
      return 'FOR EVALUATION';
    }
    if (status === 'EXPIRED SOA') {
      return 'EXPIRED SOA';
    }
    return status;
  };

  const applicationStatus = getApplicationStatus(
    get(data, 'included.bplsApplication.attributes.status')
  );

  const getTransactionStatusValue = (status, applicationStatusDetail) => {
    if (status === 'FOR CHECKING') {
      return applicationStatusDetail;
    }

    if (applicationStatusDetail === 'EXPIRED SOA') {
      return 'EXPIRED SOA';
    }
    return status || '-';
  };

  const transactionStatus = getTransactionStatusValue(
    get(data, 'attributes.transaction_status'),
    applicationStatus
  );

  const eSoaNo = get(data, 'included.bplsApplication.attributes.e_soa_no');
  const ePermitNo = get(
    data,
    'included.bplsApplication.attributes.e_permit_no'
  );
  const dataTransactionType = get(data, 'attributes.transaction_type');

  const quarter = (item) => {
    if (item === 1) return '1st';
    if (item === 2) return '2nd';
    if (item === 3) return '3rd';
    if (item === 4) return '4th';
    return '';
  };

  const newRenewalTransactions =
    ['NEW', 'RENEWAL'].indexOf(dataTransactionType) > -1;
  const barangayBusinessClearanceNumber = get(
    data,
    'included.bplsApplication.attributes.barangay_clearance_number'
  );
  const isFullRetirement = get(
    data,
    'included.bplsRetirements.attributes.is_full_retirement'
  );

  return (
    <>
      <div className="p-3" style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr className="d-flex">
              <td>
                <span className="title" style={{ fontSize: '16px' }}>
                  TRANSACTION INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Permit Type
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.permit_type') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Transaction Type
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{dataTransactionType || '-'}</b>
              </td>
            </tr>
            {dataTransactionType === 'RETIREMENT' && (
              <tr>
                <td className="text-dark" colSpan={spanGap}>
                  Retirement Type
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>{isFullRetirement ? 'FULL' : 'PARTIAL'}</b>
                </td>
              </tr>
            )}
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Date
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.transaction_date') || '-'}</b>
              </td>
            </tr>
            {newRenewalTransactions ? (
              <tr>
                <td className="text-dark" colSpan={spanGap}>
                  Barangay Business Clearance Status
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4} className="status-container">
                  <b>
                    <StatusIcon
                      value={
                        get(
                          data,
                          'included.bplsApplication.attributes.barangay_clearance_status'
                        ) || '-'
                      }
                    />
                  </b>
                </td>
              </tr>
            ) : null}
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                BPLS Status
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  <StatusIcon
                    value={transactionStatus}
                  />
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Remarks
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.remarks') || '-'}</b>
              </td>
            </tr>
            {/* <tr>
              <td className="text-dark" colSpan={spanGap}>
                Valid ID to Present
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.valid_id_to_present') || '-'}</b>
              </td>
            </tr> */}
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Transmittal No.
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{transmitallNo || '-'}</b>
              </td>
            </tr>

            <tr>
              <td className="text-dark" colSpan={spanGap}>
                TXN ID
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.txnid') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Term
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {`${quarter(
                    get(data, 'included.bplsApplication.attributes.qtr_from')
                  )} - 
                  ${quarter(
                    get(data, 'included.bplsApplication.attributes.qtr_to')
                  )}` || ''}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                E-SOA Number.
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{eSoaNo || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Reference No.
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.refno') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                OR Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.or_number') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Permit No.
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{ePermitNo || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Barangay Business Clearance Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              {dataTransactionType !== 'DELINQUENT' && (
                <td colSpan={4}>
                  <div className="d-flex justify-content-between">
                    <b>{barangayBusinessClearanceNumber || '-'}</b>
                    {Acl(permissions, [
                      'UPDATE BPLS BARANGAY CLEARANCE NUMBER',
                    ]) && get(data, 'attributes.paid_at') ? (
                      <button
                        type="button"
                        className="btn-blank"
                        onClick={handleUpdateBarangayBusinessClearanceNumber}
                      >
                        <i className="far fa-edit icon-edit" />
                      </button>
                    ) : (
                      ''
                    )}
                  </div>
                </td>
              )}
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Business Plate No.
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              {dataTransactionType !== 'DELINQUENT' && (
                <td colSpan={4}>
                  <div className="d-flex justify-content-between">
                    <b>{businessPlateNo || '-'}</b>
                    {Acl(permissions, ['UPDATE BPLS PLATE NUMBER']) &&
                    get(data, 'attributes.paid_at') ? (
                      <button
                        type="button"
                        className="btn-blank"
                        onClick={handleUpdateBusinessPlateNumber}
                      >
                        <i className="far fa-edit icon-edit" />
                      </button>
                    ) : (
                      ''
                    )}
                  </div>
                </td>
              )}
            </tr>
            <Processor
              label="Assessment By"
              name={get(data, 'attributes.assessing_by_fullname')}
              date={get(data, 'attributes.start_assess_at')}
            />
            <Processor
              label="Approved By"
              name={get(data, 'attributes.approve_by_full_name')}
              date={get(data, 'attributes.approve_at')}
            />
            <Processor
              label="Rejected By"
              name={get(data, 'attributes.reject_by_full_name')}
              date={get(data, 'attributes.reject_at')}
            />
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Remarks
              </td>
              <td colSpan={4}>
                <b>
                  <pre style={{ color: '#7790cb' }}>
                    {get(
                      data,
                      'included.bplsApplication.attributes.reject_remarks'
                    ) || '-'}
                  </pre>
                </b>
              </td>
            </tr>
            <Processor
              label="Released By"
              name={get(data, 'attributes.released_by_full_name')}
              date={get(data, 'attributes.released_at')}
            />
            <Processor
              label="SOA generated By"
              name={get(
                data,
                'included.bplsApplication.attributes.soa_generated_by'
              )}
              date={get(
                data,
                'included.bplsApplication.attributes.soa_generated_at'
              )}
            />
            <tr>
              <td className="text-primary" colSpan={spanGap}>
                <b>Payment Information</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Channel
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.payment_channel') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Branch
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.payment_channel_branch') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Date
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(data, 'included.bplsApplication.attributes.or_date_human')}
                  {/* {!_.isEmpty(_.get(data, 'included.bplsApplication.attributes.multiple_or_dates_human')) 
                    ? _.get(data, 'included.bplsApplication.attributes.multiple_or_dates_human') 
                    : _.get(data, 'included.bplsApplication.attributes.or_date_human')} */}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Status
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.status') || '-'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                OR Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(data, 'included.bplsApplication.attributes.or_no', '-')}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

TransactionInformation.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  handleUpdateBarangayBusinessClearanceNumber:
    PropTypes.instanceOf(Function).isRequired,
  handleUpdateBusinessPlateNumber: PropTypes.instanceOf(Function).isRequired,
};

export default TransactionInformation;
